import { prepareSearchParams } from "@/libs/helper";
import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";

const resource = `${Config.basePath}/call`;

export default {
  show() {
    return Client.get(`${resource}`);
  },
  update(payload, id) {
    return Client.put(`${resource}/${id}`, payload);
  },

  instruction: {
    show() {
      return Client.get(`${resource}/instruction`);
    },
    create(payload) {
      return Client.post(`${resource}/instruction`, payload);
    },
    update(payload, id) {
      return Client.put(`${resource}/instruction/${id}`, payload);
    },
    sort(payload) {
      return Client.put(`${resource}/instruction/sort`, { items: payload });
    },
    delete(id) {
      return Client.delete(`${resource}/instruction/${id}`);
    },
    search(payload) {
      return Client.post(`${resource}/instruction/search`, payload);
    },
  },

  widget: {
    show() {
      return Client.get(`${resource}/config`);
    },
    update(payload) {
      return Client.put(`${resource}/config`, payload);
    },
  },

  history: {
    index(payload) {
      return Client.get(`${resource}/session/get`, {
        params: prepareSearchParams(payload),
      });
    },
  },

  session: {
    index(payload) {
      return Client.get(`${resource}/session/list`, {
        params: prepareSearchParams(payload),
      });
    },
    detail({ id }) {
      return Client.get(`${resource}/session/${id}`);
    },
  },
};
